export default __webpack_public_path__ + "static/header-iconic-link-products-link-icon6.url-c1cc6627a16e0e5b283bb1b71aadbe0d.svg";